import { inject, Injectable, DOCUMENT } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DocumentProvider {
  private readonly document = inject(DOCUMENT);

  get location() {
    return this.document.defaultView.location;
  }
}
